import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate();
    
    return (
        <footer className="w-full bg-[#121212] px-4 py-6 border-t border-gray-800">
            <div className="max-w-7xl mx-auto flex justify-between items-center">
                {/* Copyright text */}
                <div className="text-gray-400 text-sm">
                    © 2025 Problem Spotter. All rights reserved.
                </div>

                {/* Footer Links */}
                <div className="flex gap-6">
                    <a href="mailto:info@myclok.com" className="text-gray-400 hover:text-white text-sm transition-colors">
                        Contact
                    </a>
                    <button type="button" onClick={() => navigate('/terms-and-conditions')} className="text-gray-400 hover:text-white text-sm transition-colors">
                        Terms
                    </button>
                    <button type="button" onClick={() => navigate('/privacy-policy')} className="text-gray-400 hover:text-white text-sm transition-colors">
                        Privacy
                    </button>
                </div>
            </div>
        </footer>
    );
};

export default Footer;

